module.exports = __webpack_public_path__ + "static/utilities-ca6d778dba01fac25ba631cae5edc7d3.jpg";